// src/screens/VotacionesHubScreen.js
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { db } from '../firebaseConfig';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { 
  IoArrowForward, 
  IoListCircleOutline, 
  IoVideocamOutline,
  IoStatsChartOutline
} from 'react-icons/io5';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import './AccesosScreen.css';

const HubCard = ({ to, icon, title, description, theme, badgeCount }) => (
  <Link to={to} className={`access-card ${theme}`} style={{ textDecoration: 'none' }}>
    <div className="card-icon-wrapper">
      {icon}
      {badgeCount > 0 && (
        <span className="home-badge">{badgeCount}</span>
      )}
    </div>
    <div className="card-content">
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
    <div className="card-arrow">
      <IoArrowForward size={24} />
    </div>
  </Link>
);

function VotacionesHubScreen() {
  const navigate = useNavigate();
  const { userData, currentUser } = useAuth();
  const [pendingEncuestas, setPendingEncuestas] = useState(0);
  const [activeAsambleas, setActiveAsambleas] = useState(0);

  const isAdmin = ['admin', 'comite', 'superuser', 'masteruser'].includes((userData?.rol || '').toLowerCase());
  const condoId = userData?.condominioId;

  // Escuchar encuestas pendientes
  useEffect(() => {
    if (!condoId || !currentUser) return;

    const q = query(
      collection(db, 'encuestas'),
      where('condominioId', '==', condoId)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      // Contar encuestas activas
      const now = new Date();
      const activas = snapshot.docs.filter(d => {
        const data = d.data();
        if (data.fechaFin) {
          const fin = new Date(data.fechaFin);
          return fin >= now;
        }
        return true;
      });
      setPendingEncuestas(activas.length);
    }, (err) => console.warn("Error leyendo encuestas:", err));

    return () => unsubscribe();
  }, [condoId, currentUser]);

  // Escuchar asambleas programadas / en vivo
  useEffect(() => {
    if (!condoId) return;

    const q = query(
      collection(db, 'asambleas'),
      where('condominioId', '==', condoId)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const enVivoOProximas = snapshot.docs.filter(d => {
        const data = d.data();
        return data.estatus === 'en_vivo' || data.estatus === 'programada';
      });
      setActiveAsambleas(enVivoOProximas.length);
    }, (err) => console.warn("Error leyendo asambleas:", err));

    return () => unsubscribe();
  }, [condoId]);

  return (
    <div className="ks-page">
      <KondoSidebar activeRoute={isAdmin ? "/admin/votaciones" : "/votaciones"} />

      <main className="ks-main">
        <div className="ks-header-sticky-wrapper">
          <KondoBrandHeader showBack={true} />
        </div>

        <div className="ks-scroll-area">
          <div className="muro-header-stitch">
            <div className="muro-hero-card">
              <div className="muro-hero-content">
                <h1>Votaciones y Asambleas</h1>
                <p>Democracia, consultas vecinales y juntas virtuales</p>
              </div>
              <IoStatsChartOutline className="muro-hero-icon-decor" />
            </div>
          </div>

          <div className="accesos-container" style={{ maxWidth: '900px', margin: '0 auto', padding: '0 16px' }}>
            <div className="accesos-grid">
              
              {/* Tarjeta 1: Encuestas (Consultas Vecinales) */}
              <HubCard
                to={isAdmin ? "/admin/encuestas" : "/encuestas"}
                icon={<IoListCircleOutline size={28} />}
                title="Encuestas"
                description="Consultas vecinales rápidas, opiniones y participación ciudadana en decisiones del condominio."
                theme="theme-orange"
                badgeCount={pendingEncuestas}
              />

              {/* Tarjeta 2: Asambleas Virtuales */}
              <HubCard
                to={isAdmin ? "/admin/asambleas" : "/asambleas"}
                icon={<IoVideocamOutline size={28} />}
                title="Asambleas Virtuales"
                description="Juntas formales de condóminos con validez legal, quórum en tiempo real, streaming en vivo y votaciones oficiales de orden del día."
                theme="theme-purple"
                badgeCount={activeAsambleas}
              />

            </div>
          </div>
        </div>

        <div className="ks-bottom-bar">
          <KondoBottomNav activeRoute={isAdmin ? "/admin/votaciones" : "/votaciones"} />
        </div>
      </main>
    </div>
  );
}

export default VotacionesHubScreen;
